module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//tiger_5_3.png?v=45a9072e";